var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"popup-tilte"},[_vm._v("Értéktárgyak részletes megadása")]),_vm._v(" "),_c('ValidationObserver',{ref:"form",attrs:{"slim":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var invalid = ref.invalid;
return [_c('div',{staticClass:"popup-form form d-grid"},_vm._l((_vm.getMovableTypes.valuables),function(valuableType,index){return _c('div',{key:valuableType.id,staticClass:"px-15px"},[_c('CalcElem',{attrs:{"name":"label","options":{
						type: 'label',
						wrapperClass: 'mb-15px text-center',
						className: '',
						innerClass: '',
						label: valuableType.name,
					}}}),_vm._v(" "),_c('CalcElem',{attrs:{"name":"insurance_value","index":index,"options":{
						inputGroup: 'valuables',
						type: 'text',
						unit: 'Ft',
						rules: 'number_space',
						wrapperClass: 'mb-15px',
						className: '',
						label: "Érték",
						inputmode: 'numeric',
						format: true,
					}}})],1)}),0),_vm._v(" "),_c('div',{staticClass:"sum"},[_c('span',[_vm._v("Összesen:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("toCurrency")(_vm.getValuableSum)))])]),_vm._v(" "),_c('div',{staticClass:"con-1334 navBtn"},[_c('a',{staticClass:"navBtn-next btn btn-blue",attrs:{"disabled":invalid},on:{"click":function($event){return _vm.fill()}}},[_vm._v("Tovább")])])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }